
import lightGallery from 'lightgallery';
import $ from 'jquery';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// ScrollTrigger.defaults({markers: true}); // Debug-Mode

import "./navigation";
import "./cart";
// import "./shop";

$(() =>
{
    for (let galleryElement of $('.single-project article'))
    {
        lightGallery(galleryElement as HTMLElement,
        {
            selector: 'img',
            backdropDuration: 250,
            hideControlOnEnd: true,
            download: false,
            loop: false,
            container: $('div[data-barba="container"]')[0],
            supportLegacyBrowser: false
        });
    }

    for (let galleryElement of document.getElementsByClassName('woocommerce-product-gallery__wrapper'))
    {
        lightGallery(galleryElement as HTMLElement,
        {
            selector: 'a',
            backdropDuration: 250,
            hideControlOnEnd: true,
            download: false,
            loop: false,
            container: $('div[data-barba="container"]')[0],
            supportLegacyBrowser: false
        });
    }

    scrollTriggerHeader();
});

function scrollTriggerHeader()
{
    var title = $('header.title')[0];
    var article = $('article')[0];

    if (title && article)
    {
            var articleOffset = $(article).offset()!.top;
            var h1Height = $(title).find('h1').height()! * 2;

            var timeline = gsap.timeline({
                scrollTrigger:
                {
                    trigger: article,
                    start: () => 0,
                    end: () => "+=" + h1Height,
                    scrub: true,
                }
            });
        
            timeline.to(title,
            {
                opacity: 0
            })
    }

}